const getRoot = state => state.meetings
export const status = state => getRoot(state).status
export const fetchCalendarsStatus = state => getRoot(state).fetchCalendarsStatus
export const isGoogleAuthed = state => status(state).googleAuthed
export const isMicrosoftAuthed = state => status(state).microsoftAuthed
export const getCalendars = state => getRoot(state).calendars
export const isFetchCalendarLoading = state => fetchCalendarsStatus(state) === 'pending'

export const schedulingSettings = state => getRoot(state).schedulingSettings



// WEBPACK FOOTER //
// ./src/modules/meetings/selectors.js